<template>
  <main>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.events") }}</h3>
            </template>

            <template v-slot:right-element>
              <b-button
                v-if="addEvent"
                ref="btnShow"
                @click="
                  modalShow = !modalShow;
                  resetModal();
                "
                class="btn button btn-primary"
                ><i class="icon-Add" /> {{ $t("button.addEvent") }}</b-button
              >
              <div v-if="!addEvent" class="d-flex buttons-wrapper" v-click-outside="activedAddEvent">
                <b-button ref="btnShow" @click="deleteEvent()" class="btn btn-outline-primary button btn-delete"><i class="icon-trash"></i>{{ $t("button.delete") }}</b-button>
                <b-button ref="btnShow" @click="modalShow = !modalShow" class="btn button btn-primary"><i class="icon-edit-03"></i>{{ $t("button.edit") }}</b-button>
              </div>
            </template>
          </TopTemplate>
          <div class="general-info-class classes_blocs stat row first-row justify-content-center">
            <FullCalendar :options="options">
              <!--template #eventContent="arg">
                <div class="v-cal-event-parent">
                  <div class="v-cal-event-item">
                    <div class="v-cal-event-name">
                      {{ arg.event.title }}
                    </div>
                  </div>
                </div>
              </!--template-->
            </FullCalendar>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="eventModal" v-model="modalShow" @hidden="resetModal" id="modal-prevent-closing" size="lg" centered :title="addEvent ? addEventTitle : editEventTitle" hide-footer>
      <form ref="passwordChangeForm" @submit.prevent="onSubmitCreateEvent" novalidate>
        <div class="row">
          <div class="col-md-4 p-3" ref="simpleselect">
            <div class="ajout-container__simple">
              <label>{{ $t("events.form.title") }}<sup>*</sup></label>
              <input v-model="event.title" type="text" class="form-control p-2" :class="v$.event.title.$error ? 'is-invalid' : ''" />
              <span class="invalid-feedback" v-if="v$.event.title.$error">
                {{ v$.event.title.$errors[0].$message }}
              </span>
            </div>
          </div>

          <div class="col-md-4 p-3">
            <div class="ajout-container__simple">
              <label>{{ $t("events.form.dateStart") }}<sup>*</sup></label>
              <div class="input-date">
                <Datepicker
                  v-model="event.start"
                  autoApply
                  :enable-time-picker="false"
                  locale="fr"
                  :format="format_date_v1"
                  :min-date="new Date()"
                  :class="v$.event.start.$error ? 'is-invalid' : ''"
                />
                <span v-if="v$.event.start.$error" class="invalid-feedback">
                  {{ v$.event.start.$errors[0].$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-4 p-3">
            <div class="ajout-container__simple">
              <label>{{ $t("events.form.dateEnd") }}</label>

              <div class="input-date">
                <Datepicker
                  v-model="event.end"
                  autoApply
                  :disabled="!event.start"
                  :enable-time-picker="false"
                  locale="fr"
                  :format="format_date_v1"
                  :min-date="minEndDate(event.start)"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 buttons btn-action-modal">
          <button v-if="addEvent" type="submit" :disabled="submit" class="btn button btn-primary right-btn"><i class="icon-Check"></i>{{ $t("button.add") }}</button>
          <button v-else type="submit" :disabled="submit" class="btn button btn-primary right-btn"><i class="icon-Check"></i> {{ $t("button.envoi") }}</button>
          <button
            type="button"
            @click="
              modalShow = !modalShow;
              resetModal();
            "
            :disabled="submit"
            class="btn btn-outline-primary button left-btn"
          >
            <i class="icon-Add"></i>{{ $t("button.annuler") }}
          </button>
        </div>
      </form>
    </b-modal>
  </main>
</template>

<script>
import moment from "moment";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import frLocale from "@fullcalendar/core/locales/fr";
import TopTemplate from "../components/toptemplate/TopTemplate.vue";
import EventService from "../services/events.service";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Form from "../core/Form";
import {required, helpers} from "@vuelidate/validators";
import useValidate from "@vuelidate/core";
export default {
  components: {
    Datepicker,
    TopTemplate,
    FullCalendar,
  },
  data() {
    return {
      v$: useValidate(),
      modalShow: false,
      addEvent: true,
      addEventTitle: "Ajouter un évènement",
      editEventTitle: "Modifier l'évènement",
      submit: false,
      days: [
        {name: 1, id: 1},
        {name: 2, id: 2},
        {name: 3, id: 3},
        {name: 4, id: 4},
        {name: 5, id: 5},
      ],
      name: "",
      nameState: null,
      submittedNames: [],
      eventColor: "#378006",
      options: {
        eventClick: this.handleEventClick,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        locale: frLocale,
        selectable: true,
        select: this.handleSelect,
        headerToolbar: {
          left: "prev,title,next",
          center: "",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },

        editable: true,
        dateClick: (e) => {
          //handle date click
        },
        events: [],
      },
      event: new Form({
        title: null,
        start: null,
        end: null,
        id: null,
      }),
    };
  },
  validations() {
    return {
      event: {
        title: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        start: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },
  mounted() {
    this.getEvents();
  },
  methods: {
    closeEvent() {
      this.resetModal();
    },
    onfocusin() {
      const that = this;
      setTimeout((ev) => {
        that.$refs.dp1.isOpen || that.$refs.dp1.showCalendar(ev);
      }, 50);
    },
    handleSelect() {
      this.resetModal();
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD") !== "Invalid date" ? moment(String(value)).format("YYYY-MM-DD") : null;
      }
    },
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY") !== "Invalid date" ? moment(String(value)).format("DD-MM-YYYY") : null;
      }
    },
    resetModal() {
      this.event.title = null;
      this.event.start = null;
      this.event.end = null;
      this.event.id = null;
      this.addEvent = true;
      this.v$.event.title.$reset();
      this.v$.event.start.$reset();
    },
    activedAddEvent() {
      this.addEvent = false;
    },
    minEndDate(start) {
      return moment(start).format("YYYY-MM-DD");
    },
    handleEventClick(clickInfo) {
      const that = this;
      setTimeout(function () {
        that.$nextTick(() => {
          that.event = {
            id: clickInfo.event.id,
            start: that.format_date(clickInfo.event.start),
            end: moment(clickInfo.event.end).add(-1, "d").format("YYYY-MM-DD"),
            title: clickInfo.event.title,
          };
          that.scrollToTop();
          that.addEvent = false;
        });
      }, 5);
    },
    getEvents() {
      // this.loading = true;
      EventService.getAll({
        params: {},
      }).then(
        (response) => {
          let data = response.data.data;
          data.map((item, index) => {
            item.end = moment(item.end).add(1, "d").format("YYYY-MM-DD");
          });
          this.options.events = data;
          this.scrollToTop();
          this.resetModal();
        },
        (error) => {
          if (error.response && error.response.status === 403) {
              this.$router.push('/error-403');
            }
          console.error(error);
        }
      );
    },
    onSubmitCreateEvent() {
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        this.submit = true;
        this.$nextTick(() => {
          this.event.id ? this.editEventAction() : this.addEventAction();
        });
      }
    },

    addEventAction() {
      const data = {
        start: this.format_date(this.event.start),
        end: this.format_date(this.event.end),
        title: this.event.title,
      };

      EventService.create(data)
        .then(
          (response) => {
            response.data.end = moment(response.data.end).add(1, "d").format("YYYY-MM-DD");
            this.options.events.push(response.data);
          },
          (error) => {
            console.error(error);
          }
        )
        .finally(() => {
          this.$nextTick(() => {
            this.submit = false;
            this.modalShow = false;
          });
        });
    },
    editEventAction() {
      const data = {
        start: this.format_date(this.event.start),
        end: this.format_date(this.event.end),
        title: this.event.title,
      };

      EventService.update(this.event.id, data)
        .then(
          () => {
            this.getEvents();
          },
          (error) => {
            console.error(error);
          }
        )
        .finally(() => {
          this.$nextTick(() => {
            this.submit = false;
            this.modalShow = false;
          });
        });
    },
    deleteEvent() {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Êtes-vous sûr de vouloir supprimer cette evenement?",
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire("L'evenement a été supprimé avec succès !", "", "success");
            EventService.delete(this.event.id).then(
              () => {
                this.getEvents();
              },
              (error) => {
                console.error(error);
              }
            );
            // StudentService.delete(id);
            // this.$router.push({ name: 'student_list' });
          }
        });
    },
  },
};
</script>
<style>
.btn-delete {
  margin-right: 10px;
}
.btn-action-modal {
  text-align: right;
}
.left-btn,
.right-btn {
  float: right;
}
.left-btn .icon-Add {
  transform: rotate(45deg);
}
.right-btn {
  margin-left: 10px;
}
.fc .fc-button-group > .fc-button {
  margin: 0 10px;
  border-radius: 10px;
  padding: 16px 26px;
  background-color: #f3f2f7;
  color: #464255;
  border: none;
  font-weight: 500;
  font-size: 16px;
}
.fc .fc-button-primary:not(:disabled):active,
.fc .fc-button-primary:not(:disabled).fc-button-active {
  background-color: rgba(52, 185, 187, 0.15);
  border: 1px solid #34b9bb;
  color: #464255;
  font-weight: 500;
  font-size: 16px;
}
.fc .fc-button-primary:not(:disabled):active:focus,
.fc .fc-button-primary:not(:disabled).fc-button-active:focus {
  box-shadow: none;
}
.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child),
.fc-direction-ltr .fc-button-group > .fc-button:not(:first-child) {
  border-radius: 10px;
}
.fc .fc-toolbar-title {
  display: inline-block;
  padding: 0 10px;
  text-transform: capitalize;
  font-size: 14px;
}
.fc .fc-button-primary,
.fc .fc-button-primary:hover {
  background-color: unset;
  border: 1px solid #fff;
  color: #34b9bb;
}
.fc .fc-button-primary:not(:disabled):active {
  font-weight: unset;
  font-size: unset;
}
.fc .fc-button-primary:focus {
  box-shadow: none;
}
.fc .fc-button .fc-icon {
  vertical-align: middle;
  font-size: 20px;
  margin-top: -4px;
}

.fc-h-event {
  background-color: #f5a88c;
  border: none;
  text-align: center;
}
.fc-h-event:active,
.fc-h-event:focus,
.fc-h-event:visited {
  opacity: 0.8;
}
.fc-daygrid-day-events .fc-daygrid-event-harness:nth-of-type(1) a {
  background-color: #34b9bb;
}
.fc-daygrid-day-events .fc-daygrid-event-harness:nth-of-type(2) a {
  background-color: #34b9bb;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  margin-right: 8px;
}
.fc-direction-ltr .fc-daygrid-event.fc-event-start,
.fc-direction-rtl .fc-daygrid-event.fc-event-end {
  margin-left: 8px;
}
.fc-button-group {
  display: none !important;
}
.fc-daygrid-day-top a {
  color: #464255;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
}
.fc .fc-daygrid-day.fc-day-today {
  background-color: #f3f2f7;
}
.fc .fc-daygrid-day-top {
  flex-direction: row;
  padding-left: 16px;
  padding-top: 16px;
}
.fc-scrollgrid-sync-inner a {
  white-space: normal;
  color: #464255;
  font-size: 12px;
  font-weight: 400;
  text-decoration: none;
  text-transform: capitalize;
}
.fc-theme-standard th {
  border-right: none;
  border-left: none;
}
.fc-theme-standard .fc-scrollgrid {
  border-top: none;
  border-left: none;
}
.fc .fc-scrollgrid-section-body table {
  border-left: 1px solid #eceaf3;
}
.fc-theme-standard td {
  border: 1px solid #eceaf3;
}
.btn-close {
  color: #111111;
  opacity: 1;
}
</style>
